import { createContext, useContext } from "react";
const defaultConfig = {
    resolvedConfig: void 0,
    resolvedDisplay: void 0,
    resolvedFeatures: void 0,
    resolvedPayload: void 0,
    chatbotFeatures: void 0
};
const ConfigContext = createContext(defaultConfig);
const useConfig = ()=>{
    const context = useContext(ConfigContext);
    if (!context) throw new Error('useConfig must be used within a ConfigProvider');
    return context;
};
export { ConfigContext, useConfig };
